import { render, staticRenderFns } from "./PushSubscribersCount.vue?vue&type=template&id=984e1c4c&"
import script from "./PushSubscribersCount.vue?vue&type=script&lang=ts&"
export * from "./PushSubscribersCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports